import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

const PermissionWrapper = ({ 
  children, 
  requiredPermission, 
  requiredRole, 
  fallback = null,
  showFallback = true 
}) => {
  const { hasPermission, hasRole } = usePermissions();

  // Vérifier les permissions
  let hasAccess = true;

  // Vérifier la permission spécifique
  if (requiredPermission && !hasPermission(requiredPermission)) {
    hasAccess = false;
  }

  // Vérifier le rôle spécifique
  if (requiredRole && !hasRole(requiredRole)) {
    hasAccess = false;
  }

  // Si pas d'accès, retourner le fallback ou null
  if (!hasAccess) {
    return showFallback ? fallback : null;
  }

  return children;
};

export default PermissionWrapper;

